import React, { Component } from 'react';
import styles from '../components/Newspaper.module.css';


class Newspaper_3_col extends Component 
{
     
  renderElement(element, index) 
  {
    //----- Direct image is an object with a 'src' property -----
    if (element.src) 
    {
      return <img key={index} src={element.src} width={element.width} alt={element.alt || 'Image'} className={styles.image} />;
    }

    //----- Shadow image header -----
    if (element.shadow)
    {
      return <p className={styles.image_shadow}> {element.shadow} </p>
    } 

  //----- Text header -----
  if (element.header)
    {
      return <p key={index} className={styles.headline}>{element.header}</p>;      
    } 

    if (element.text)
    {
      //console.log('text:', element.text);
      return <p key={index} className={styles.text}> {element.text}</p>;      
    }
    return '' 
  }


  render() 
  {
    const { textLines } = this.props;

    return (
      <div className={styles.text_block}>
        <div className={styles.multi_column_3}>
          {textLines.map((element, index) => this.renderElement(element, index))}
      </div>
      </div>
    );
  }
}

export default Newspaper_3_col
